<template>
    <div>
      <div class="dashboard__section dashboard_updates dashboard_updates2">
        <div
          class="dashboard_cnt fulldashboard"
          
        >
          <div class="dashboard_left">
            <div class="grid_actions">
            <div class="type-filters">
                <ul>
                  <li :class="{'current':selecetedTab=='TODO'}" @click="changeTab('TODO')"> To-Do</li>
                  <li :class="{'current':selecetedTab=='CASES'}" @click="changeTab('CASES')"> Cases</li>
                  <li :class="{'current':selecetedTab=='TASK'}" @click="changeTab('TASK')"> Tasks</li>
                  <li :class="{'current':selecetedTab=='UPDATES'}" @click="changeTab('UPDATES')"> My Updates</li>

                </ul>
         
            </div>
          
          </div>
            <div class="dashboard_left_cnt todo_list dashboard_left_cnt2" >
              <!-- <VuePerfectScrollbar
              ref="mainSidebarPs"
              class="scroll-area--main-sidebar"
              :settings="settings"
              @ps-scroll-y="scroll"
              > -->
                <div class="dashboard_skelton" v-if="isLodaing">
                  <div class="skelton_cards" v-for="index in 1" :key="index">
                    <div class="skline line1"></div>
                    <div class="skline line2"></div>
                    <div class="skline line3"></div>
                    <div class="user_skelton">
                      <div class="skline picture"></div>
                      <div>
                        <div class="skline line2"></div>
                        <div class="skline line3"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="!isLodaing && list.length > 0">
                    <!-- <updatesItem :updatesList="list"  :ref="'dashboardUpdatesTab'" /> -->
                    <template v-for="(wallItem, ind) in list">
    <div :wallItemAction="checkProperty( wallItem ,'action')"  :wallItemDataCategory="checkProperty( wallItem ,'data' , 'category') " :action="checkProperty( wallItem ,'action' )" :category="checkProperty( wallItem ,'data' , 'category') " :class="{'updates-widget':checkProperty(widgetData ,'code')=='UPDATES'}"  class="widget-task-list"  :key="ind">
       
        <div class="task-details">
            <h5><a @click="item=wallItem;goToDetailPage()">{{checkProperty( wallItem ,"title" )}}</a></h5> 
            <div class="discription">
              <p><a @click="item=wallItem;goToDetailPage()">{{checkProperty( wallItem ,"description" )}}</a></p>
              <template v-if="( checkProperty(wallItem ,'type') =='activity' || checkProperty(wallItem ,'type') =='todo' || checkProperty(widgetData ,'code')=='UPDATES')&& checkProperty( wallItem ,'createdByName' )">
                
                  <small>
                   {{ checkProperty(wallItem ,'type') =='activity'?'Updated By':'Created By' }} <div><strong>{{ wallItem['createdByName'] }}</strong><template v-if="checkProperty( wallItem ,'createdByRoleName' )"> ({{checkProperty( wallItem ,'createdByRoleName' )}})</template></div>
                   </small>
                
              </template> 
            </div>
            <div class="documents" v-if="checkProperty( wallItem , 'data','documents')">
              <template v-for="(fItem, findex) in checkProperty( wallItem , 'data','documents')" >
                <span :key="findex" v-tooltip.top-center="checkProperty(fItem ,'name')"   v-on:click.stop.prevent="downloads3file(fItem)"  class="note pointer cursor">
                  <docType  :item="fItem" />
                  
                </span>
              </template>
            </div>
        </div>
    </div> 
     </template>
                  <div class="loading_list" v-if="loader">Loading
                    <div class="loading">
                        <span class="loading__dot"></span>
                        <span class="loading__dot"></span>
                        <span class="loading__dot"></span>
                    </div>                    
                  </div>
                </div>
                <div v-else-if="!isLodaing && list.length <= 0">
                  <NoDataFound
                    ref="NoDataFoundRef"
                    :loading="false"
                    :heading="'No ' + 'Data' + ' Found'"
                    type="User Roles"
                  />
                </div>
              <!-- </VuePerfectScrollbar> -->
            </div>
          </div>
        </div>

      </div>
    </div>
  </template>
   
   
  <script>
  import vsInvDropdown from "@/views/vs-inv-dropdown.vue";
  import VueApexCharts from "vue-apexcharts";
  import Vue from "vue";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import { MoreVerticalIcon } from "vue-feather-icons";
  import DateRangePicker from "vue2-daterange-picker";
  import Avatar from "vue-avatar";
  import WallMessage from "@/views/wall/message.vue";
  import selectField from "@/views/forms/fields/simpleselect.vue";
  import updatesItem from "@/views/dashboard/dashboardUpdatesItem";
  //import activityItem from "./wall/activityItem.vue";
  import _ from "lodash";
  import NoDataFound from "@/views/common/noDataFound.vue";
  import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
  Vue.use(VueApexCharts);
  import Paginate from "vuejs-paginate";
  
  import JQuery from "jquery";
  Vue.component("apexchart", VueApexCharts);
  import casesChart from "@/views/wall/casesChart.vue";
  import usersChart from "@/views/wall/usersChart.vue";
  import lcaChart from "@/views/wall/lcaChart.vue";
  import invoiceChart from "@/views/wall/invoiceChart.vue";
  import moment from "moment";
  import Multiselect from "vue-multiselect-inv";
  import VueSlimScroll from "vue-slimscroll";
  import DatePickerCustom from "@/views/common/_date_picker_custom.vue";
  import caseItem from "@/views/petition/caseItem.vue";
  Vue.use(VueSlimScroll);
  var _isotope;
  export default {
    provide() {
      return {
        parentValidator: this.$validator,
      };
    },
    components: {
      vsInvDropdown,
        selectField,
      caseItem,
      DatePickerCustom,
      Paginate,
      WallMessage,
      Avatar,
      VuePerfectScrollbar,
      MoreVerticalIcon,
      DateRangePicker,
      updatesItem,
    //  activityItem,
      NoDataFound,
      Multiselect,
      casesChart,
      usersChart,
      lcaChart,
      invoiceChart,
    },
    data: function () {
      return {
        tenantTodoList:[],
        assignmentActivityes:[],
        petitionToDoList:[],
        item:null,
        selecetedTab:'TODO',
        autoApply: "",
        userRoleType:'petitioner',
        petitionerSearchValue:'',
        branchList:[],
        petitionerList:[],
        caseTypesList:[],
        caseSubTypeList:[],
        selectedBranch:[],
        selectedPetitioner:[],
        selectedCaseSubType:[],
        selectedCaseType:null,
        selectedStatus:null, 
        selected_NewsDateRange:["", ""],
        statusList:[{'id':1,'name':"Created"},{'id':2,'name':"Approved"},{'id':3,'name':"Deleted"}],
         settings: { 
          swipeEasing: false,
        },
        caseStatusList:[],
        allCaseTypes:[],
        userRolelist: [],
          all_statusids: [],
  
  
        lableData: [],
      
        wallsLoaded: false,
        pendingActionsCount: 0,
        tabDataName: "Tasks",
        isOpenDateFilter: false,
        subItem: false,
        selected_createdDateRange: [],
        autoApply: "",
        list: [],
        itemCount: 0,
        caseListTypes: ["Deadlines", "Latest"],
        caseListType: "Deadlines",
        scorlOptions: {
          height: "100%",
          size: 0,
        },
      
        templateClass: "box",
        windowHight: 0,
        callFromSerch: false,
        itemTemplate: [],
        isLodaing: true,
        loader:false,
        tabName: "todo",
        perPage: 25,
        page: 1,
  
        gap: 0,
        frame: [
          [1, 1, 2, 2],
          [3, 3, 2, 2],
          [4, 4, 4, 5],
        ],
        rectSize: 0,
        useFrameFill: true,
        dateRange: {
          // startDate: '2019-12-26',
          // endDate: '2019-12-28',
        },
        username: "",
        activities: [],
        // options: {},
        series: [50, 102, 155, 141, 117],
        dashboard_data: {},
        lca_requests: [],
        new_petitioners: [],
        new_petitions: [],
        petitionersCount: {},
        beneficiaryStats: {},
  
        petitionsCount: {},
        rfe_petitions: [],
  
        //recent activity data
        recent_activitys: [],
        my_tasks: [],
        roleId: 0,
        wallFilterData: {
          filters: {
            types: ["todo"], // all, todo activity
            createdDateRange: [],
          },
          page: 1,
          perpage: 25,
          sorting: {
            path: "createdOn",
            order: -1,
          },
        },
        jaquery: null,
        filterText: "Today",
        isListloading: false,
        allCaseList: [],
        todayCaseList: [],
        tomorrowCaseList: [],
        groupedlist: [],
        missedDeadLineCaseList: [],
        getMissingDeadlines: false,
        deadlineDateRange: [],
        callFromTabChange:false,
        totalUpdatesCount:0,
      };
    },
  
    mounted() {
        this.petitionToDoList = ["CREATE_PETITION" ,'SUBMIT_BY_BENEFICIARY','LCA_REQUEST' ,'SUBMIT_TO_LAW_FIRM' ,'ASSIGN_SUPERVISOR' ,"ASSIGN_PARALEGAL" ,"ASSIGN_DOCUMENTATION_MANAGER","ASSIGN_DOCUMENTATION_EXECUTIVE" ,"ASSIGN_ATTORNEY" ,"REQUEST_DOC_EXECUTIVE_TO_UPLOAD","UPLOAD_BY_DOC_EXECUTIVE" ,"CASE_APPROVED"]
        this.assignmentActivityes = ['ASSIGN_SUPERVISOR' ,"ASSIGN_CASE_APPROVER","ASSIGN_PARALEGAL" ,"ASSIGN_DOCUMENTATION_MANAGER","ASSIGN_DOCUMENTATION_EXECUTIVE" ,"ASSIGN_ATTORNEY"]
        this.tenantTodoList = ['TENANT_CREATED' ];
        this.getVisaTypes();
        this.getPetitioners();
        this.getBranchList();
        if([50].indexOf(this.getUserRoleId)>-1){
            this.userRoleType = 'beneficiary'
        }


     /*
      this.getCaseStatusList(),
      this.getVisaTypes(); 
      this.getCompanyStatusList();
      this.getUserRoles();
      */
      this.$store.dispatch("commonAction" ,{data:{} ,path:"/masterdata/list-for-dashboard"}).then((res)=>{
         /*
          this.caseStatusList
          this.allCaseTypes 
          this.userRolelist
          this.all_statusids
  
         */
        // alert(JSON.stringify(res))
          this.allCaseTypes = this.checkProperty( res,'petitionTypeList');
          this.caseStatusList = this.checkProperty( res,'petitionStatusList');
          this.userRolelist = this.checkProperty( res,'userRoleList');
          this.all_statusids = this.checkProperty( res,'companyStatusList');
          this.all_statusids = _.filter(this.all_statusids, (item) => {
              return [1, 2, 3, 4].indexOf(item["id"]) > -1;
          });
          
  
      }).catch((error)=>{}) 
  
  
  
     
      this.isListloading = true;
  
      this.$store
        .dispatch("getList", {
          data: { category: "WORKFLOW" },
          path: "/messages/list",
        })
        .then((response) => {
          //alert(JSON.stringify(response))
          this.lableData = response.messages.WORKFLOW;
        });
      this.wallsLoaded = false;
      this.filterText = "";
      this.jaquery = JQuery;
      
      
      this.username = this.$store.state.user.name;
      //  this.roleId = this.$store.state.user['roleId'][0];
  
      this.petitionsCount = {
        petitionCount: 0,
        rfeCount: 0,
        totalCount: 0,
      };
      this.petitionersCount = {
        approvedCount: 0,
        pendingCount: 0,
        totalCount: 0,
      };
      this.beneficiaryStats = {
        total: 0,
        active: 0,
        inactive: 0,
      };
  
      //this.get_dashboardData();
      // this.get_recentActivitys();
      // this.get_mytasks();
      // this.getactivities();
      this.wallFilterData = {
        filters: {
          types: [this.tabName], // all, todo activity
          createdDateRange: [],
        },
        page: this.page,
        perpage: this.perPage,
        sorting: {
          path: "createdOn",
          order: -1,
        },
      };
      this.wallList();
      // this.myresizeEventHandler();
      this.filterCasesList();
    },
  
    created() {
      window.addEventListener("resize", this.myresizeEventHandler);
    },
    destroyed() {
      window.removeEventListener("resize", this.myresizeEventHandler);
    },
    methods: {
      goToDetailPage(){
            let category = this.checkProperty( this.item ,"data" , "category");
  
             if( this.checkProperty(this.item ,'data' ,'navigationKey')  == "TASK_DETAILS"){
  
                 let taskId = this.checkProperty(this.item ,"data", "taskId");
                 
                  let path =  {'path':"/tasks-list" ,"query":{}};
                 if(taskId) {
                   path["query"]['id'] =taskId
                   this.$router.push(path);
  
                 }
                  
  
  
            }else if( this.checkProperty(this.item ,'data' ,'navigationKey')  == "CAP_DETAILS"){
              let caseId = this.checkProperty(this.item ,'data' ,'petitionId');
              if(caseId) {
                this.$router.push({ path: `/cap-registration-details/${caseId}` ,query: {'filter':''} })
              }
              
            }else if( this.checkProperty(this.item ,'data' ,'navigationKey')  == "TENANT_DETAILS"){
  
                 let tenantId = this.checkProperty(this.item ,"data", "tenantId");
                 if(tenantId) this.$router.push("/customer-details/"+tenantId);
  
  
            }else  if((this.checkProperty(this.item ,'data' ,'navigationKey')=='LCA_DETAILS') ){
              
                let lcaId = this.checkProperty( this.item ,'data',"lcaId" );
                if(lcaId){
                    this.$router.push("/lca-inventory-details/"+lcaId);
                }else if(this.checkProperty( this.item ,'data',"petitionId" )){
                  let petitionId =  this.checkProperty( this.item ,'data',"petitionId" );
                  this.$store.dispatch("setPetitionTab" , 'set_LCA');
                  this.findDetailsPage(petitionId);

                }
  
            }else if(this.petitionToDoList.indexOf(category)>-1  ||  this.checkProperty(this.item ,'data' ,'navigationKey') =='PETITION_DETAILS' || this.checkProperty(this.item ,'data' ,'navigationKey') =='PERM_DETAILS'   ){
              
              this.navigateToDetails(this.item ,'CASE_DETAILS' ,'');
                   
  
            }else if( this.tenantTodoList.indexOf(category)>-1 || ['TENANT_STATUS_UPDATE'].indexOf(category)>-1){
  
                 let tenantId = this.checkProperty(this.item ,"data", "tenantId");
                 if(tenantId)
                    this.$router.push("/customer-details/"+tenantId);
            }else if( this.checkProperty(this.item ,'data' ,'navigationKey')=='USER_DETAILS'){
  
                this.$router.push("/users");
            }
            else if( this.checkProperty(this.item ,'data' ,'navigationKey')=='COMPANY_DETAILS'){
             
                let companyId = this.checkProperty(this.item ,"data", "companyId")
                if(companyId)
                   this.$router.push("/petitioner-details/"+companyId);
            }else if( ['TICKET_DETAILS'].indexOf(this.checkProperty(this.item ,'data' ,'navigationKey'))>-1){
             
                let ticketId = this.checkProperty(this.item ,"data", "ticketId");
                if(ticketId)
                   this.$router.push("/ticket-details/"+ticketId);
            }else if(['I9_DETAILS'].indexOf(this.checkProperty(this.item ,'data' ,'navigationKey'))>-1){
              let routeId = this.checkProperty(this.item, 'data','i9Id')
              if(routeId){
                this.$router.push("/i9-details/"+routeId);
              }
         }
            
        },
        getCaseSubTypes(){
            this.selectedCaseSubType = [];
            if (this.selectedCaseType && _.has(this.selectedCaseType, "id")) {
                let item = {
                matcher: {
                    getAllSubTypes: false,
                    searchString: '',
                    petitionType: parseInt(this.selectedCaseType['id']),
                    getWorkFlowConfig: false,
                },
                page: 1,
                perpage: 1000,
                category: "petition_sub_types",
                "sorting": {
                    "path": "name",
                    "order": 1
                }
                };
                this.$store.dispatch("getMasterData", item).then((response) => {
                this.caseSubTypeList = response.list;
                });
            }
        },
        getVisaTypes() {
            let item = {
                matcher: {
                "searchString": '',
                getWorkFlowConfig: true
                // "petitionType":

                },
                page: this.page,
                perpage: this.perpage,
                category: "petition_types",
                "sorting": {
                "path": "name",
                "order": 1
                }

            };
            this.$store.dispatch("getMasterData", item)
            .then(response => {
                if(response && response.list && this.checkProperty(response.list, 'length')>0){
                    this.caseTypesList = response.list;
                }
            });
        },
        getPetitioners() {
            let item = {
                page: 1,
                perpage: 10000,
                category: "petitioner_list_for_tenant_users",
                matcher: {
                    "searchString": this.petitionerSearchValue,

                },
                "sorting": {
                    "path": "name",
                    "order": 1
                }
            };
            this.$store.dispatch("getMasterData", item).then(response => {
                this.petitionerList = response.list;
            });
        },
        getBranchList() {
            this.branchList = [];
            let item = {
                filters: {
                    "title": '',
                    "createdDateRange": [],
                    "statusList": [],
                    "activeList": [],
                    "countryIds": [],
                    "stateIds": [],
                    "locationIds": []
                },
                getMasterData: true,
                page: 1,
                perpage: 1000,
                sorting: { "path": "createdOn", "order": -1 },
            };
            this.$store.dispatch("getList", { "data": item, "path": "/branch/list" })
            .then(response => {
                if (response && response.list && response.list.length >0) {
                    this.branchList = response.list;
                }
            }).catch((error) => {
                this.branchList = [];
            })
        },
        clear_filter(){
            this.selectedBranch = [];
            this.selectedPetitioner = [];
            this.selectedCaseSubType = [];
            this.selectedCaseType = null;
            this.wallFilterData['page'] = 1;
            this.selected_NewsDateRange["startDate"] = "";
            this.selected_NewsDateRange["endDate"] = "";
            this.wallList();
            // this.$refs["filter_menu"].dropdownVisible = false;
            document.body.classList.remove('scroll-hidden');
        },
        set_filter(){
            this.wallFilterData['page'] = 1;
            this.wallList();
            // this.$refs["filter_menu"].dropdownVisible = false;
            document.body.classList.remove('scroll-hidden');
        },
        getCaseStatusList() {
            
    
            this.$store
            .dispatch("get_petition_statusids")
            .then(response => {
                this.caseStatusList = response;
            });
        },
        getUserRoles() {
            let query = {};
            query["page"] = 1;
            query["perpage"] = 100;
            query["matcher"] = {};
            query["category"] = "user_roles";
    
            this.$store
            .dispatch("getMasterData", query)
            .then((response) => {
                this.userRolelist = response.list;
            })
            .catch(() => {});
        },
        getCompanyStatusList() {
            this.all_statusids = [];
            let postdata = {
            page: 1,
            perpage: 1000,
            category: "company_status",
            };
            this.$store
            .dispatch("getMasterData", postdata)
            .then((res) => {
                this.all_statusids = res["list"];
                this.all_statusids = _.filter(this.all_statusids, (item) => {
                return [1, 2, 3, 4].indexOf(item["id"]) > -1;
                });
            })
            .catch(() => {});
        },
    
    
        filterCasesList(type = "Deadlines") {
            /*
            caseListTypes: ['Latest', 'Deadlines'],
            caseListType:'Latest',
            */
            if (this.caseListType == "Latest") {
            this.deadlineDateRange = [];
            this.getMissingDeadlines = false;
            } else {
            let today = moment();
            let tomorrow = moment().add(7, "days");
            let yesterday = moment().add(-1, "days");
            this.deadlineDateRange = [today, tomorrow];
            this.getMissingDeadlines = true;
            }
            this.isListloading = true;
            this.getpetitions();
        },
    
        getpetitions() {
            let self = this;
            //  allCaseList:[],
            // todayCaseList:[],
            // tomorrowCaseList:[],
            //missedDeadLineCaseList
    
            let postData = {
            matcher: {
                //	"rfeCases": true,
                searchString: "",
                petitionerIds: [],
                beneficiaryIds: [],
                statusIds: [],
                typeIds: [],
                subTypeIds: [],
                genders: [],
                maritalStatusIds: [],
                countryIds: [],
                stateIds: [],
                locationIds: [],
                createdDateRange: [],
                getMasterDataOnly: false, // Send true when needs master data only
                lcaStatusIds: [],
                invoiceStatusIds: [],
                getMissingDeadlines: self.getMissingDeadlines,
                deadlineDateRange: self.deadlineDateRange,
            },
            page: 1,
            perpage: 20,
            sorting: {
                path: "createdOn", //deadlineDays, updatedOn, createdByName, typeName, subTypeName, caseNo, statusName, clientName, beneficiaryName
                order: 1,
            },
            today: moment().format("YYYY-MM-DD"),
            };
            this.isListloading = true;
            this.allCaseList = [];
            this.todayCaseList = [];
            this.tomorrowCaseList = [];
            this.missedDeadLineCaseList = [];
    
            this.$store
            .dispatch("petitioner/getpetitions", postData)
            .then((response) => {
                this.isListloading = false;
    
                this.allCaseList = _.cloneDeep(response.list);
                if (this.caseListType == "Deadlines") {
                //find todayCaseList  ,   tomorrowCaseList ,  missedDeadLineCaseList;
                var futurecases = _.filter(response.list, (item) => {
                    let today = moment().startOf("day");
                    let deadlineDate = moment(item["deadlineDate"]).startOf("day");
                    return deadlineDate.isSameOrAfter(today);
                });
    
                this.missedDeadLineCaseList = _.filter(response.list, (item) => {
                    let today = moment().startOf("day");
                    let deadlineDate = moment(item["deadlineDate"]).startOf("day");
                    return deadlineDate.isBefore(today);
                });
    
                var result = _.chain(futurecases)
                    .groupBy((datum) =>
                    moment(new Date(datum.deadlineDate)).startOf("day").format()
                    )
                    .map((items, id) => ({
                    date: id,
                    items: items,
                    }))
                    .value();
    
                    this.groupedlist = _.sortBy(result, "date");
                }
    
                //alert(this.totalpages);
            })
            .catch((err) => {
                this.isListloading = false;
                this.allCaseList = [];
                this.todayCaseList = [];
                this.tomorrowCaseList = [];
                this.missedDeadLineCaseList = [];
            });
        },
        
        getStats() {
            //  this.statusCount =0;
            let payLoad = {
            categoryList: ["pending-actions-count"], //["case-stats-by-status", "pending-actions-count", "lca-stats-by-status", "invoice-stats-by-status", "petitioner-stats-by-status", "pending-cases-stats", "case-aging-stats"],
            matcher: {
                statusIds: [],
                typeIds: [],
                subTypeIds: [],
                createdDateRange: [],
            },
            };
    
            payLoad["matcher"]["createdDateRange"] =
            this.wallFilterData["filters"]["createdDateRange"];
    
            this.$store
            .dispatch("getStats", payLoad)
            .then((result) => {
                if (_.has(result, "pendingActionsCount")) {
                this.pendingActionsCount = result["pendingActionsCount"];
                }
            })
            .catch((err) => {
                this.pendingActionsCount = 0;
            });
        },
    
        togleDateFIlter() {
            this.isOpenDateFilter = !this.isOpenDateFilter;
            // if(this.isOpenDateFilter){
            //     document.addEventListener("click", ()=>{
            //         this.isOpenDateFilter =false;
    
            //     });
            // }
        },
    
        reloadWall(seleteddates) {
            if (seleteddates && seleteddates.startDate != null) {
            this.wallFilterData["filters"]["createdDateRange"] = [];
            this.wallFilterData["filters"]["createdDateRange"] = [
                seleteddates.startDate,
                seleteddates.endDate,
            ];
            } else {
            this.wallFilterData["filters"]["createdDateRange"] = [];
            }
            this.wallList();
        },

        scroll(e) {
            const { target } = e;
            if (
            !this.callFromTabChange &&
            Math.ceil(target.scrollTop) >=
            target.scrollHeight - target.offsetHeight 
            ) {
            //this code will run when the user scrolls to the bottom of this div so
            //you could do an api call here to implement lazy loading
           
            if (this.wallFilterData['page'] < this.countTotalPages) {
            //  this.page = this.page + 1;
                this.wallFilterData['page'] = this.wallFilterData['page']+1;
                this.wallList(true);
            }
            }
        },
    
        
    
        myresizeEventHandler() {
            this.windowHight = window.screen.height; // window.innerHeight;
        },
    
        pageNate(pageNum) {
            this.page = pageNum;
    
            this.wallFilterData = {
            filters: {
                types: [this.tabName], // all, todo activity
                createdDateRange: [],
            },
            page: this.page,
            perpage: this.perPage,
            sorting: {
                path: "createdOn",
                order: -1,
            },
            };
            this.wallList();
        },
        updateLoading(value) {
            setTimeout(() => {
            try {
                if (this.$refs["NoDataFoundRef"]) {
                this.$refs["NoDataFoundRef"].updateLoading(value);
                }
            } catch (err) {
            }
            }, 100);
            return;
        },
        changeTab(tab='TODO'){
        //this.widgetData['tabName'] = tab;
        //this.$emit('changeTab' ,tab);
        this.selecetedTab = tab;

        this.getWigetsData();

        
                
       
      },
      getWigetsData() {
            let path ="dashboard/get-widget-data";
      let postData ={
        getStats:false,
        categoryList:['ACTION'],
        filters:{},
        perpage:500
      };
       if(this.selecetedTab == 'UPDATES'){
            postData['filters']['types'] = ['activity'];
            postData['filters']["entityTypeList"] = [];

        }

        if(['TODO'].indexOf(this.selecetedTab)>-1){
            postData['filters']['types'] = ['todo'];
            postData['filters']["entityTypeList"] = [];

        }
        if(['CASES'].indexOf(this.selecetedTab)>-1){
             postData['filters']['types'] = ['todo'];
             postData['filters']["entityTypeList"] = ["petition"];
            
        }
        if(['TASK'].indexOf(this.selecetedTab)>-1){
            postData['filters']['types'] = ['todo'];
            postData['filters']["entityTypeList"] = [ "task"];
        }
            
            
            this.$store.dispatch("commonAction", { data: postData, path: path })

            .then((respons) => {
            //console.log(JSON.stringify(response));
            let response = [];
            this.list = respons['ACTION']['data']
            // if(respons && _.has(respons, 'UPDATES') && _.has(respons['UPDATES'], 'totalCount')){
            //     this.totalUpdatesCount = respons['UPDATES']['totalCount'];
            // }
            // if(respons && _.has(respons, 'UPDATES') && _.has(respons['UPDATES'], 'data') && respons['UPDATES']['data'].length >0){
            //     response = respons['UPDATES']['data'];
            // }
            // alert(callFromSerch)
                // if( !callFromSerch){
                // //  this.list = [];
                //    // this.list = response;
                //     this.$refs['dashboardUpdatesTab'].initIsotop()
                // }else{
                //  let tempList = _.cloneDeep( this.list );
                // _.forEach(response ,(item)=>{
                //     this.list.push(item) 
                //     tempList.push(item);
                // })
                // //  this.list = [];
                // //  this.list = _.cloneDeep(tempList)
                
                setTimeout(()=>{
                    //this.$refs['dashboardUpdatesTab'].initIsotop(true);
                    this.loader = false;
                })
                
                
                
                
    
                // }
            
                this.isLodaing = false;
                this.updateLoading(false);
                this.callFromTabChange =false;
                /*
                setTimeout(() => {
                jQuery(".db_grid").isotope({
                    layoutMode: "packery",
                    itemSelector: ".grid_element",
                    masonry: {
                    horizontalOrder: true,
                    },
                });
                if (jQuery(".db_grid").height() <= 50) {
                    jQuery(".db_grid").height("auto");
                    var _h = jQuery(".db_grid").innerHeight();
                    jQuery(".db_grid").height(_h);
                }
    
                
                // this.$vs.loading.close();
                }, 0);
                */
                
                this.wallsLoaded = true;
                //alert(this.perpage);
                this.updateLoading(false);
            })
            .catch(() => {
                this.loader = false;
                this.wallsLoaded = true;
                // this.$vs.loading.close();
                this.updateLoading(false);
                jQuery(".db_grid").isotope({
                layoutMode: "packery",
                itemSelector: ".grid_element",
                });
                this.isLodaing = false;
                this.callFromTabChange =false;
            });
        },
        changedTab(tabName = "all") {
            var _prevtab = this.tabName;
            this.callFromTabChange =true;
            this.page = 1;
            this.tabName = tabName;
            this.wallFilterData = {
            filters: {
                types: [this.tabName], // all, todo activity
                createdDateRange: [],
            },
            page: 1,
            perpage: this.perPage,
            sorting: {
                path: "createdOn",
                order: -1,
            },
            };
            //this.tabDataName  = 'Activities ';
            // if('todo'==this.tabName || 'activity'==this.tabName){
            //       this.tabDataName  = 'Tasks ';
            // }
    
            this.tabDataName = "Activities ";
            if ("todo" == this.tabName || "activity" == this.tabName) {
            //   if('todo'==this.tabName){
            //        jQuery('.db_grid').isotope({ filter: '.todo' })
    
            //   }
            //    if('todo'==this.tabName){
            //         jQuery('.db_grid').isotope({ filter: '.activity' })
    
            //   }
    
            this.tabDataName = "Tasks ";
            }
        
    
            this.wallList();
        },
        wallList(isCallFromSerch=false) {
            this.getWigetsData();
        },
        get_dashboardData: function () {
            this.$store.dispatch("get_dashboard_data", {}).then((response) => {
            this.dashboard_data = response;
            this.lca_requests = this.dashboard_data["lca_requests"]
                ? this.dashboard_data["lca_requests"]
                : [];
    
            this.petitionsCount = this.dashboard_data["petitionsCount"]
                ? this.dashboard_data["petitionsCount"]
                : {
                    petitionCount: 0,
                    rfeCount: 0,
                    totalCount: 0,
                };
            this.petitionersCount = this.dashboard_data["petitionersCount"]
                ? this.dashboard_data["petitionersCount"]
                : {
                    approvedCount: 0,
                    pendingCount: 0,
                    totalCount: 0,
                };
            this.beneficiaryStats = this.dashboard_data["beneficiaryStats"]
                ? this.dashboard_data["beneficiaryStats"]
                : {
                    total: 0,
                    active: 0,
                    inactive: 0,
                };
    
            this.new_petitioners = this.dashboard_data["new_petitioners"]
                ? this.dashboard_data["new_petitioners"]
                : [];
            this.new_petitions = this.dashboard_data["new_petitions"]
                ? this.dashboard_data["new_petitions"]
                : [];
            this.rfe_petitions = this.dashboard_data["rfe_petitions"]
                ? this.dashboard_data["rfe_petitions"]
                : [];
            });
        },
        get_recentActivitys: function () {
            this.$store.dispatch("get_recent_activitys", {}).then((response) => {
            this.recent_activitys = response.list;
            });
        },
        getactivities: function () {
            this.$store.dispatch("getactivities").then((response) => {
            this.activities = response;
            });
        },
        get_mytasks: function () {
            this.$store.dispatch("get_my_tasks", {}).then((response) => {
            this.my_tasks = response.list.map((element) => {
                //"navigationKey":
    
                element["data"]["navigation_link"] = "#";
                if (element["data"]["navigationKey"] == "USER_DETAILS")
                if (element["data"]["navigationKey"] == "COMPANY_DETAILS")
                    // element["data"]['navigation_link'] ="#/company/details/"+element["data"]['companyId'];
    
                    element["data"]["navigation_link"] =
                    "/company/details/" + element["data"]["companyId"];
    
                if (element["data"]["navigationKey"] == "PETITION_DETAILS")
                element["data"]["navigation_link"] =
                    "/petition-details/" + element["data"]["petitionId"];
    
                if (element["data"]["navigationKey"] == "LCA_DETAILS")
                element["data"]["navigation_link"] =
                    "/lca-details/" + element["data"]["lcaId"];
    
                if (element["data"]["description"].includes("questionnaire "))
                element["data"]["navigation_link"] =
                    "/questionnaire/" + element["data"]["petitionId"];
    
                return element;
            });
            //this.my_tasks = a//response.list;
            });
        },
        refresh() {
            // alert("REFERESH");
            this.get_recentActivitys();
        },
    },
    computed: {
      generateGreetings() {
        var currentHour = moment().format("HH");
  
        if (currentHour >= 3 && currentHour < 12) {
          return "Good Morning";
        } else if (currentHour >= 12 && currentHour < 15) {
          return "Good Afternoon";
        } else if (currentHour >= 15 && currentHour < 20) {
          return "Good Evening";
        } else if (currentHour >= 20 && currentHour < 3) {
          return "Good Night";
        } else {
          return "Hello";
        }
      },
      countTotalPages() {
        return (this.totalpages = Math.ceil(
          this.totalUpdatesCount / this.perPage
        ));
      },
      user() {
        return this.$store.state.user;
      },
      getToDoWallListCount() {
        let returnVal = 0;
        let todoList = _.filter(this.getWallList.list, { type: "todo" });
        if (todoList) {
          returnVal = todoList.length;
        }
        return returnVal;
      },
    },
  };
  </script>
  